const PATH_SEPARATOR = '°|°'

// Champs de la fiche d'expérience repris tels quels par l'application, ou destinés au seul atelier.
const UNTRANSLATED_EXPERIENCE_FIELDS = ['orientation', 'publicTarget', 'typeStructure', 'newUntil', 'clientName', 'clientSite']

// Extrait les textes traduisibles d'un document (expérience, module, point ou parcours).
// `type` nomme la collection du document racine et `root` le document lui-même : les exceptions ciblées
// s'en servent pour écarter un champ précis sans priver de traduction les clés homonymes des autres documents.
export default function jsonToArray(path, json, type = '', root = json) {
  path = path || ''
  let lines = []
  const character = json.character || '' // pour les voix lues dans les conversations

  if (json.tourinsoftId || json.deleted) return []

  for (const key in json) {
    const value = json[key]

    // Série de conditions où un élément (valeur ou objet) ne doit pas étre traduit.
    if (!value) continue // Si pas de valeur.
    if (['cases', 'defaultActions'].includes(key)) continue // Supprime les traductions du module Switch.
    if (['firstActions', 'actions', 'onStart', 'onResume'].includes(key)) continue // Supprime les traductions des actions.
    if (key === 'mode') continue // Pas de traduction sur le mode du Cluedo.
    if (key === 'key' && path.startsWith('ratings')) continue // Pour ne plus traduire les clés des notations.
    if (key === 'name' && path.startsWith('targets')) continue // Nom des cibles RA.
    if (key === 'typeEG') continue // Type d'Explor Games.
    if (key === 'sightType') continue // Type de visée de la boussole.
    if (key === 'resizeMode') continue
    // Grosse liste de cas que je n'ai pas envie de simplifier/expliquer...
    if (
      [
        'character',
        'characters',
        'authorizations',
        'theme',
        'timers',
        'type',
        'uid',
        '_id',
        'position',
        'size',
        'updatedBy',
        'updatedAt',
        'createdAt',
        'color',
        'scoreType',
        'file',
        'dropType',
        'internalName',
        'locale',
        'notes',
        'tourinsoftId',
        'inputType',
        'beacons',
        'align',
        'variable'
      ].indexOf(key) >= 0
    ) {
      continue
    }

    // Exceptions ciblées : chacune ne vaut que pour le type de document et l'emplacement nommés.
    if (type === 'experiences') {
      // Critères de classement et métadonnées de la fiche ; titre, description et tags restent traduits.
      if (path === '' && UNTRANSLATED_EXPERIENCE_FIELDS.includes(key)) continue
      // Catégories de l'enquête et leurs variantes : repères d'édition, jamais affichés dans l'application.
      if (path === '' && key === 'categories') continue
      if (key === 'name' && path.startsWith('popups' + PATH_SEPARATOR)) continue // Titre interne d'un popup.
      if (key === 'key' && path.startsWith('tos' + PATH_SEPARATOR + 'checkboxes' + PATH_SEPARATOR)) continue // Clé des CGU.
    }
    // Un module Switch n'a pas d'écran : son titre ne sert qu'à le repérer dans l'atelier.
    if (type === 'modules' && path === '' && key === 'title' && root.type === 'switch') continue

    // Si la valeur est une chaine de caractères, on ne traduit pas certains cas (ID, URL).
    if (typeof value === 'string') {
      if (value.match(/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/) || value.match(/^[a-f0-9]{24}$/)) continue
      if (value.match(/^https:\/\/.+$/)) continue

      lines.push({ path: path ? path + PATH_SEPARATOR + key : key, text: value, character }) // Traduction de l'élément.
      continue
    }

    // Si value est un objet ou un tableau, la fonction devient récursive pour aller plus en profondeur.
    if (Array.isArray(value) || typeof value === 'object') {
      lines = lines.concat(jsonToArray(path ? path + PATH_SEPARATOR + key : key, value, type, root))
    }
  }
  return lines
}
